<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
              <h3>Update Campaign</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />


          <div class="vx-row mb-6" v-if="sd_compliance_warning">
            <div class="vx-col w-full">
              <vs-alert active="true" color="warning" icon="warning">
                {{ sd_compliance_warning }}
              </vs-alert>
            </div>
          </div>


          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span> Campaign Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="campaign_name" v-model="campaignDescription.campaign_name"
                v-validate="'required'" data-vv-as="Campaign Name" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('campaign_name')">{{
              errors.first("campaign_name")
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Campaign Code:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="campaign_code" v-model="campaignDescription.campaign_code"
                v-validate="'required'" data-vv-as="Campaign Code" @change="CheckUniqueCampaignCode" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('campaign_code')">{{
              errors.first("campaign_code")
            }}</span>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Campaign Manager:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <CampaignManagerAutocomplete :key="campaignSearchComponentKey" class="searchbox"
                :list="searchCampaignManager" :searchOn="'search_campaign_manager'" @event-name="handleCampaignManager">
              </CampaignManagerAutocomplete>
            </div>
            <div class="vx-col sm:w-1/4 w-full">
              {{ prevCampaignManager }}
              <vs-icon v-if="prevCampaignManager" class="removeButton ml-5"
                @click="removeSelectedCampaignManager(campaignDescription.campaign_manager)" color="success"
                icon="clear">
              </vs-icon>
            </div>

            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('campaign_manager')">{{
              errors.first("campaign_manager")
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Start Date:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <datepicker v-validate="'required'" data-vv-as="Start Date" :language="$vs.rtl ? langHe : langEn"
                name="start_date" v-model="campaignDescription.start_date" :disabledDates="disabledStartDates">
              </datepicker>
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('start_date')">{{ errors.first("start_date")
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>End Date:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <datepicker v-validate="'required'" data-vv-as="End Date" :language="$vs.rtl ? langHe : langEn"
                name="end_date" v-model="campaignDescription.end_date" :disabledDates="disabledEndDates"></datepicker>
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('end_date')">{{ errors.first("end_date")
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Setup:</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <v-select label="po_number" name="setup_purchase_order_id" :options="PurchaseOrderList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="campaignDescription.setup_purchase_order_id" />

            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input @input="onSetupInput" type="number" class="w-full" name="setup"
                v-model="campaignDescription.setup" data-vv-as="Setup" />
            </div>


          </div>
          <vs-divider class="m-5" />
          <div class="">
            <template v-for="(purchase_order, ind) in campaignDescription.purchase_orders">

              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>PO Number:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <POAutocomplete :key="'po_' + ind"  class="searchbox" :list="searchPO" :searchOn="'search_po'"
                    @event-name="handleSelectedPO(ind)">
                  </POAutocomplete>


                </div>

                {{ purchase_order.po_number }}


                <vs-icon class="ml-10 removeButton" @click="removePurchaseOrder(purchase_order)" color="success"
                  icon="clear"></vs-icon>
              </div>




              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>PO Value Allocated to Campaign:</span>
                </div>



                <div class="vx-col sm:w-1/6 w-full">
                  <vs-input type="number" class="w-full"
                    v-model="campaignDescription.purchase_orders[ind]['allocated_value']" name="allocated_value"
                    @change="refreshAutocomplete" @input="onAllocationInput(ind)" />


                </div>
                {{ purchase_order.remaining_po_value ? 'Available :' + purchase_order.remaining_po_value : null }}

              </div>

            </template>
          </div>

          <div class="text-center mb-5">
            <vs-button color="primary" @click="addPurchaseOrders" type="filled">Add PO</vs-button>
          </div>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Target Pipeline:</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input type="number" class="w-full" name="target_pipeline"
                v-model="campaignDescription.target_pipeline" v-validate="'required'" data-vv-as="Target Pipeline" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('target_pipeline')">{{
              errors.first("target_pipeline")
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Daily Rate:</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input type="number" class="w-full" name="budget" v-model="campaignDescription.daily_rate"
                v-validate="'required'" data-vv-as="Daily Rate" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('daily_rate')">{{ errors.first("daily_rate")
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Target Number of Opportunities:</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input type="number" class="w-full" name="target_no_of_opportunities"
                v-model="campaignDescription.target_no_of_opportunities" v-validate="'required'"
                data-vv-as="Target Number of Opportunities" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('target_no_of_opportunities')">{{
              errors.first("target_no_of_opportunities")
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Target Number of VACs:</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input type="number" class="w-full" name="target_no_of_vacs"
                v-model="campaignDescription.target_no_of_vacs" v-validate="'required'"
                data-vv-as="Target Number of VACs" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('target_no_of_vacs')">{{
              errors.first("target_no_of_vacs")
            }}</span>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"> <span>No Sales Developer required:</span> </div>
            <div class="vx-col sm:w-1/3 w-full"> <vs-checkbox v-model="campaignDescription.noSdRequired"
                @change="onNoSdRequiredToggle"></vs-checkbox> </div>
          </div>



          <div class="" v-if="!campaignDescription.noSdRequired">




            <template v-for="(sales, index) in campaignDescription.sales_developers">

              <div class="vx-row" :key="'sd_row_' + sales.counter">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Sales Developer {{ index + 1 }}:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">

                  <v-select v-model="sales.full_name" :options="allSalesDevelopers" class="new_select_class" /><br>

                  <!-- <SalesDeveloperAutocomplete :key="companySearchComponentKey" class="searchbox"
                    :list="searchSalesDeveloper" :searchOn="'selected_sales_developer'"
                    @event-name="handleSalesDeveloper(index)"></SalesDeveloperAutocomplete> -->
                </div>
                <vs-icon class="ml-10 removeButton" @click="removeSelectedSalesDeveloper(sales)" color="success"
                  icon="clear"></vs-icon>
              </div>
            </template>

            <SdAllocationPanel v-if="!campaignDescription.allocationExempt" :sales-developers="campaignDescription.sales_developers"
              :option-list="allSalesDevelopers" :start-date="campaignDescription.start_date"
              :end-date="campaignDescription.end_date" :campaign-id="campaignId" :budget-days="sdBudgetDays"
              :edit-mode="true" row-name-key="full_name" @change="onSdAllocationChange" />

          </div>

          <div class="text-center m-5" v-if="!campaignDescription.noSdRequired">
            <span class="text-danger text-sm mt-2 mr-10" v-show="errors.has('sales_developer')">{{
              errors.first("sales_developer")
            }}</span>
            <vs-button color="primary" @click="addSalesDeveloper" type="filled">Add Sales Developer</vs-button>
          </div>

          <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Internal campaign (SD time not allocated):</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-checkbox v-model="campaignDescription.allocationExempt"></vs-checkbox>
          </div>
        </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Campaign Status:</span>
            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <!-- <v-select v-validate="'required'" required label="campaign_status" name="campaign_status"
                :options="campaignStatusList"
                v-model="campaignDescription.selected_campaign_status" data-vv-as="Campaign Status" /> -->



              <select v-model="campaignDescription.selected_campaign_status" class="w-full v-select-box p-2">
                <option v-for="item in campaignStatusList" :value="item">{{ item.campaign_status }}
                </option>
              </select>
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('campaign_status')">{{
              errors.first("campaign_status")
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Briefing Document:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input @change="uploadBriefingDocument" ref="briefing_document" type="file" class="w-full"
                name="briefing_document" v-model="briefing_document" />
            </div>
            {{ campaignDescription.briefing_document }}
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>End Of Campaign Report:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input @change="uploadEndOfCampaignReport" ref="end_of_campaign_report" type="file" class="w-full"
                name="end_of_campaign_report" v-model="end_of_campaign_report" />
            </div>
            {{ campaignDescription.end_of_campaign_report }}
          </div>

          <!-- <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Opportunities Documents:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button color="primary" @click="showOpportunityDocs" type="filled">Download</vs-button>

            </div>
          </div> -->

          <vs-divider class="m-5" />
          <div class="">


            <template v-for="(client, index) in campaignDescription.clients">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Primary Client:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-radio v-model="primary_client" :vs-value="client.client_id"></vs-radio>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Client:</span>
                </div>

                <!-- {{client}} -->
                <div class="vx-col sm:w-1/3 w-full">
                  <ClientAutocomplete :key="clientSearchComponentKey" class="searchbox" :list="searchClient"
                    :searchOn="'searched_clients'" @event-name="handleClientEvent(index)"></ClientAutocomplete>
                </div>
                {{ client.client_name }}
                <vs-icon class="ml-10 removeButton" @click="removeSelectedClient(client)" color="success" icon="clear">
                </vs-icon>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Primary Client Contact:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <PrimaryContactAutocomplete :key="primaryConctSearchComponentKey" class="searchbox"
                    :list="getPrimaryContacts" :searchOn="'search_primary_contacts'"
                    @event-name="handlePrimaryContacts(index)"></PrimaryContactAutocomplete>
                </div>
                {{ client.primary_contact_name }}

              </div>

              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Other Client Contact:</span>
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-button color="primary" @click="addOtherClientContact(client, index)" type="filled">Add Client
                    Contact</vs-button>
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                  <template v-for="otn in client.other_contact_name">

                    <span v-if="(otn.id != client.primary_contact_id)">{{ otn.first_name }} {{ otn.surname }}</span>
                    <br>
                  </template>


                </div>
              </div>

              <vs-divider class="p-2" />
            </template>
            <div class="text-center mb-5">
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('client')">{{ errors.first("client")
              }}</span>
            </div>
          </div>
          <div class="text-center mb-5">
            <vs-button color="primary" @click="addClients" type="filled">Add Clients</vs-button>
          </div>







          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Client Dashboard:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button color="primary" @click="listClientDashboardDataSets" type="filled">Add Dashboard</vs-button>

              <template v-for="client_dashboard, i in campaignDescription.campaign_dashboard">
                <div class="mt-4 mb-4">

                  <span>{{ client_dashboard.name }} </span>

                  <vs-icon class="ml-10 removeButton" @click="showSelectedClientDashboardPermission(client_dashboard)"
                    color="dark" icon="clear">ⓘ
                  </vs-icon>

                  <vs-icon class="ml-10 removeButton" @click="removeExistingClientDashboard(client_dashboard)"
                    color="danger" icon="clear"></vs-icon>
                  <br>

                </div>



              </template>
            </div>

          </div>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Alert Recipients:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <div class="vx-row mb-6">

                <div class="vx-col sm:w-1/2 w-full">
                  <vs-button color="primary" @click="showAlertRecipients" type="filled">Add Alert Recipients</vs-button>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <template v-for="ar in campaignDescription.alert_recipients">

                    <span>{{ ar.first_name }} {{ ar.surname }}</span>
                    <br>
                  </template>
                </div>
              </div>



            </div>

          </div>


          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Select Docs Template:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <div class="vx-row mb-6">

                <div class="vx-col sm:w-1/2 w-full">
                  <vs-button color="primary" @click="showDocsTemplate" type="filled">Select</vs-button>
                </div>
                <div class="vx-col sm:w-1/2 w-full" v-if="selected_docs_template">

                  {{ selected_docs_template.name }}
                </div>
              </div>



            </div>

          </div>



          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Select Email Template:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <div class="vx-row mb-6">

                <div class="vx-col sm:w-1/2 w-full">
                  <vs-button color="primary" @click="showEmailTemplate" type="filled">Select</vs-button>
                </div>
                <div class="vx-col sm:w-1/2 w-full" v-if="selected_email_template">
                  {{ selected_email_template.name }}
                </div>
              </div>



            </div>

          </div>


          <vs-divider class="m-5" />


          <div class="">
            <template v-for="(elomark_user,
              index) in campaignDescription.user_campaign_association">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Elomark User:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <ElomarkUserAutocomplete :key="elomarkUserSearchComponentKey" class="searchbox"
                    :list="searchElomarkUser" :searchOn="'selected_elomark_user'"
                    @event-name="handleElomarkUserEvent(index)"></ElomarkUserAutocomplete>
                </div>
                {{
                  typeof elomark_user.first_name !== "undefined"
                    ? elomark_user.first_name + " " + elomark_user.surname
                    : null
                }}
                <vs-icon class="ml-10 removeButton" @click="removeSelectedElomarkUser(elomark_user)" color="success"
                  icon="clear"></vs-icon>
              </div>
            </template>
            <div class="text-center mb-5">
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('privileged_elomark_user')">{{
                errors.first("privileged_elomark_user")
              }}</span>
            </div>
          </div>
          <div class="text-center">
            <vs-button color="primary" @click="addElomarkUser" type="filled">Add Elomark User</vs-button>
          </div>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm">Submit</vs-button>
            </div>
          </div>
        </vx-card>
      </form>
    </div>
    <vs-popup fullscreen title="Choose Dashboard" :active.sync="listClientDashboardDataSetsPopup">
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span>Search :</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-input type="text" class="w-full" name="search_filter" v-model="search_filter" @keyup="updatePaginate" />
        </div>

      </div>
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span> </span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">

          <div class="vx-row mb-6 all_dashboard_rows"
            v-for="dashboard, index in filterBy(client_dashboard_lists, search_filter, 'name')"
            v-show="setPaginate(index)">
            <div class="vx-col w-full">
              <span>{{ dashboard.name }}</span>
              <vs-radio class="ml-10" v-model="selected_dashboard" :vs-value="dashboard"></vs-radio>
            </div>
          </div>
        </div>

      </div>
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span> </span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">

          <div class="pagination mb-5">
            <a href="#" class="btn btn-default" v-for="page_index in paginate_total"
              @click.prevent="updateCurrent(page_index)">
              {{ page_index }}
            </a>
          </div>

          <span class="text-danger text-sm" v-show="errors.has('client_dashboard_required')">{{
            errors.first("client_dashboard_required")
          }}</span>
        </div>

      </div>



      <form data-vv-scope="AddEditClientDashboard">


        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span> Name:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input class="w-full" name="AddEditClientDashboard.client_dashboard_custom_name"
              v-model="client_dashboard_custom_name" v-validate="'required'" data-vv-as="Dashboard Name" />
          </div>
          <div class="text-center mb-5">
            <span class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('AddEditClientDashboard.client_dashboard_custom_name')">{{
                errors.first("AddEditClientDashboard.client_dashboard_custom_name")
              }}</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Description:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input class="w-full" name="AddEditClientDashboard.client_dashboard_custom_description"
              v-validate="'required'" v-model="client_dashboard_custom_description"
              data-vv-as="Dashboard Description" />
          </div>
          <div class="text-center mb-5">
            <span class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('AddEditClientDashboard.client_dashboard_custom_description')">{{
                errors.first("AddEditClientDashboard.client_dashboard_custom_description")
              }}</span>
          </div>
        </div>


        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>HTML:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">


            <vs-textarea rows="6" v-validate="'required'" class="w-full" name="AddEditClientDashboard.html"
              v-model="html" data-vv-as="Html" />


          </div>
          <div class="text-center mb-5">
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('AddEditClientDashboard.html')">{{
              errors.first("AddEditClientDashboard.html")
            }}</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full"></div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-button class="mr-3 mb-2" @click.prevent="submitDashboardSelection">Select Dashboard</vs-button>
          </div>
        </div>

      </form>


    </vs-popup>
    <vs-popup fullscreen title="Dashboard User Permission"
      :active.sync="listClientDashboardDataSetsUserPermissionPopup">
      <template v-for="(client, index) in campaignDescription.clients">
        <!-- {{client}} -->

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Client:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ client.client_name }}
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Primary Client Contact:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ client.primary_contact_name }}
          </div>
          <div class="vx-col sm:w-1/4 w-full">

            <vs-checkbox v-model="client_dashboard_user_permission_client_user"
              :checked="client_dashboard_user_permission_client_user.some(e => e == client.uuid)"
              :vs-value="client.primary_contact_id"></vs-checkbox>

          </div>
        </div>

        <template v-for="other_contact in client.other_contact_name">
          <div class="vx-row mb-6" v-if="client.primary_contact_id != other_contact.id">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Other Client Contact:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ other_contact.first_name }} {{ other_contact.surname }}
            </div>
            <div class="vx-col sm:w-1/4 w-full">
              <vs-checkbox v-model="client_dashboard_user_permission_client_user"
                :checked="client_dashboard_user_permission_client_user.some(e => e == client.uuid)"
                :vs-value="other_contact.id"></vs-checkbox>
            </div>

          </div>
        </template>

        <vs-divider class="m-5" />
      </template>







      <template v-for="(elomark_user,
        index) in campaignDescription.user_campaign_association">
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Elomark User:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{
              typeof elomark_user.first_name !== "undefined"
                ? elomark_user.first_name + " " + elomark_user.surname
                : null
            }}
          </div>
          <div class="vx-col sm:w-1/4 w-full">

            <vs-checkbox v-model="client_dashboard_user_permission_elomark_user"
              :checked="client_dashboard_user_permission_elomark_user.some(e => e == elomark_user.uuid)"
              :vs-value="elomark_user.id"></vs-checkbox>


          </div>

        </div>
      </template>




      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full"></div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-button class="mr-3 mb-2" v-if="update_client_dashboard_user_permission"
            @click.prevent="updateDashboardUserPermissionSelection">Update</vs-button>
          <vs-button class="mr-3 mb-2" v-if="!update_client_dashboard_user_permission"
            @click.prevent="submitDashboardUserPermissionSelection">Submit</vs-button>

        </div>
      </div>


    </vs-popup>
    <vs-popup title="Add Client Contact" :active.sync="showClientContactPopup">

      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span>Search :</span>
        </div>


        <div class="vx-col sm:w-1/2 w-full">
          <vs-input type="text" class="w-full" name="client_contact_search_filter"
            v-model="client_contact_search_filter" @keyup="clientContactUpdatePaginate" />

          <div class="vx-row mb-6 all_client_contact_rows mt-5"
            v-for="all_contact, index in filterBy(all_client_contact, client_contact_search_filter, 'first_name', 'surname')"
            v-show="clientContactSetPaginate(index)">
            <div class="vx-col sm:w-1/2 w-full">

              {{ all_contact.first_name }} {{ all_contact.surname }}

            </div>




            <div class="vx-col sm:w-1/4 w-full">


              <vs-checkbox @change="clientContactOnChange($event, all_contact)" v-model="selected_client_contact"
                :id="all_contact.id" :checked="selected_client_contact.some(e => e.id == all_contact.id)"
                :vs-value="all_contact">
              </vs-checkbox>

            </div>



          </div>


        </div>

      </div>
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span> </span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">

          <div class="pagination">

            <a href="#" class="btn btn-default" v-for="page_index in client_contact_paginate_total"
              @click.prevent="clientContactUpdateCurrent(page_index)">
              {{ page_index }}
            </a>
          </div>
        </div>

      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full"></div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-button class="mr-3 mb-2" @click.prevent="selectOtherClientContact">Select</vs-button>
        </div>
      </div>


    </vs-popup>

    <vs-popup fullscreen title="Alert Recipients" :active.sync="showAlertRecipientsPopup">

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Opportunity Owner:</span>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <vs-checkbox v-model="campaignDescription.alert_opportunity_owner"></vs-checkbox>
        </div>
      </div>
      <vs-divider class="m-5" />

      <template v-for="(client, index) in campaignDescription.clients">
        <!-- {{client}} -->


        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Client:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ client.client_name }}
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Primary Client Contact:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ client.primary_contact_name }}
          </div>
          <div class="vx-col sm:w-1/4 w-full">

            <vs-checkbox v-model="alert_recipients_client_user"
              :checked="alert_recipients_client_user.some(e => e == client.uuid)"
              :vs-value="client.primary_contact_id"></vs-checkbox>

          </div>
        </div>

        <template v-for="other_contact in client.other_contact_name">
          <div class="vx-row mb-6" v-if="client.primary_contact_id != other_contact.id">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Other Client Contact:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ other_contact.first_name }} {{ other_contact.surname }}
            </div>
            <div class="vx-col sm:w-1/4 w-full">
              <vs-checkbox v-model="alert_recipients_client_user"
                :checked="alert_recipients_client_user.some(e => e == client.uuid)"
                :vs-value="other_contact.id"></vs-checkbox>
            </div>

          </div>
        </template>

        <vs-divider class="m-5" />
      </template>


      <template v-for="(elomark_user,
        index) in campaignDescription.user_campaign_association">
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Elomark User:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{
              typeof elomark_user.first_name !== "undefined"
                ? elomark_user.first_name + " " + elomark_user.surname
                : null
            }}
          </div>
          <div class="vx-col sm:w-1/4 w-full">

            <vs-checkbox v-model="alert_recipients_elomark_user"
              :checked="alert_recipients_elomark_user.some(e => e == elomark_user.uuid)"
              :vs-value="elomark_user.id"></vs-checkbox>


          </div>

        </div>
      </template>




      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full"></div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-button class="mr-3 mb-2" @click.prevent="updateAlertRecipientsSelection">Submit</vs-button>

        </div>
      </div>


    </vs-popup>


    <vs-popup fullscreen title="Choose Docs Template" :active.sync="showDocsTemplatePopup">
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span>Search :</span>
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <vs-input type="text" class="w-full" name="docs_template_search_filter" v-model="docs_template_search_filter"
            @keyup="docsTemplateUpdatePaginate" />
        </div>

      </div>
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span> </span>
        </div>
        <div class="vx-col sm:w-1/4 w-full">


          <div class="vx-row mb-6 all_docs_template_rows"
            v-for="docs, index in filterBy(docs_template_lists, docs_template_search_filter, 'name')"
            v-show="docsTemplateSetPaginate(index)">
            <div class="vx-col w-full">

              <span>{{ docs.name }}</span>

              <input class="ml-10" type="radio" v-if="selected_docs_template" name="selected_docs_template"
                v-bind:value="docs" :checked="selected_docs_template.id == docs.id" v-model="selected_docs_template">

              <input class="ml-10" type="radio" v-else name="selected_docs_template" v-bind:value="docs"
                v-model="selected_docs_template">
            </div>
          </div>
        </div>

      </div>
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span> </span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">

          <div class="pagination mb-5">
            <a href="#" class="btn btn-default" v-for="page_index in docs_template_paginate_total"
              @click.prevent="docsTemplateUpdateCurrent(page_index)">
              {{ page_index }}
            </a>
          </div>
        </div>

      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full"></div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-button class="mr-3 mb-2" @click.prevent="submitDocsTemplate">Select Template</vs-button>
        </div>
      </div>


    </vs-popup>

    <vs-popup fullscreen title="Choose Email Template" :active.sync="showEmailTemplatePopup">
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span>Search :</span>
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <vs-input type="text" class="w-full" name="email_template_search_filter"
            v-model="email_template_search_filter" @keyup="emailTemplateUpdatePaginate" />
        </div>

      </div>
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span> </span>
        </div>
        <div class="vx-col sm:w-1/4 w-full">


          <div class="vx-row mb-6 all_email_template_rows"
            v-for="email, index in filterBy(email_template_lists, email_template_search_filter, 'name')"
            v-show="emailTemplateSetPaginate(index)">
            <div class="vx-col w-full">

              <span>{{ email.name }}</span>

              <input class="ml-10" type="radio" v-if="selected_email_template" name="selected_email_template"
                v-bind:value="email" :checked="selected_email_template.id == email.id"
                v-model="selected_email_template">

              <input class="ml-10" type="radio" v-else name="selected_email_template" v-bind:value="email"
                v-model="selected_email_template">
            </div>
          </div>
        </div>

      </div>
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span> </span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">

          <div class="pagination mb-5">
            <a href="#" class="btn btn-default" v-for="page_index in email_template_paginate_total"
              @click.prevent="emailTemplateUpdateCurrent(page_index)">
              {{ page_index }}
            </a>
          </div>
        </div>

      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full"></div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-button class="mr-3 mb-2" @click.prevent="submitEmailTemplate">Select Template</vs-button>
        </div>
      </div>


    </vs-popup>

    <vs-popup fullscreen title="Opportunity Documents" :active.sync="showOpportunityDocsPopup">
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span>Search :</span>
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <vs-input type="text" class="w-full" name="opportunity_docs_search_filter"
            v-model="opportunity_docs_search_filter" @keyup="opportunityDocsUpdatePaginate" />
        </div>

      </div>
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span> </span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">

          <div class="vx-row mb-6 all_opportunity_docs_rows"
            v-for="docs, index in filterBy(opportunity_docs_lists, opportunity_docs_search_filter, 'name')"
            v-show="opportunityDocsSetPaginate(index)">
            <div class="vx-col w-full">


              <div class="vx-row mb-1">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>{{ docs.name }}</span>
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-checkbox v-model="selected_opportunity_docs" :vs-value="docs"></vs-checkbox>

                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span> </span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">

          <div class="pagination mb-5">
            <a href="#" class="btn btn-default" v-for="page_index in opportunity_docs_paginate_total"
              @click.prevent="opportunityDocsUpdateCurrent(page_index)">
              {{ page_index }}
            </a>
          </div>
        </div>

      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full"></div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-button class="mr-3 mb-2" @click.prevent="downloadOpportunityDocs">Download</vs-button>
        </div>
      </div>


    </vs-popup>


  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import modulePurchaseOrdersManagement from "@/store/campaign-management/purchase-orders-management/modulePurchaseOrdersManagement.js";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import moduleClientManagement from "@/store/clients-management/moduleClientsManagement.js";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import moduleClientUserManagement from "@/store/client-user-management/moduleClientUserManagement.js";
import CampaignManagerAutocomplete from "@/components/autocomplete/CampaignManagerAutocomplete.vue";
import SalesDeveloperAutocomplete from "@/components/autocomplete/SalesDeveloperAutocomplete.vue";
import PrimaryContactAutocomplete from "@/components/autocomplete/PrimaryContactAutocomplete.vue";
import ElomarkUserAutocomplete from "@/components/autocomplete/ElomarkUserAutocomplete.vue";
import Vue2Filters from 'vue2-filters'
import POAutocomplete from "@/components/autocomplete/POAutocomplete.vue";
import Datepicker from "vuejs-datepicker";
import { en, he } from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import moment from "moment";
import { saveAs } from 'file-saver';
import currency from "currency.js"
import SdAllocationPanel from "./SdAllocationPanel.vue";
export default {
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      campaignId: null,  // <-- ADD THIS
      html: null,
      allSalesDevelopers: [],
      sdAllocationState: { allocations: [], allocatedDays: 0, hasBlocked: false, valid: true },
      sd_compliance_warning: null,
      previous_selected_po_setup_id: null,
      initial_setup_value: null,
      temp_setup_purchase_order_id: null,
      PurchaseOrderList: [],
      all_po_data: [],
      selected_po_numbers: [],
      POsearchComponentKey: 0,
      selected_available_po_value: 0,
      opportunity_docs_lists: [],
      showOpportunityDocsPopup: false,
      showDocsTemplatePopup: false,
      showEmailTemplatePopup: false,
      alert_recipients_elomark_user: [],
      alert_recipients_client_user: [],
      showAlertRecipientsPopup: false,
      existing_client_contacts: [],
      selected_client_dashboard_for_update_permission: {},
      update_client_dashboard_user_permission: false,
      selected_client_contact: [],
      all_client_contact: [],
      other_contact_id_index: null,
      showClientContactPopup: false,
      user_id: null,
      client_dashboard_custom_name: null,
      client_dashboard_custom_description: null,
      client_dashboard_user_permission_client_user: [],
      client_dashboard_user_permission_elomark_user: [],
      main_client_dashboard_counter: 0,
      selected_client_dashbashboards: [
      ],
      selected_docs_template: {},
      docs_template_current: 1,
      docs_template_paginate: 10,
      docs_template_paginate_total: 0,
      docs_template_search_filter: '',
      selected_opportunity_docs: [],
      opportunity_docs_current: 1,
      opportunity_docs_paginate: 10,
      opportunity_docs_paginate_total: 0,
      opportunity_docs_search_filter: '',
      selected_email_template: {},
      email_template_lists: [],
      email_template_current: 1,
      email_template_paginate: 10,
      email_template_paginate_total: 0,
      email_template_search_filter: '',
      current: 1,
      paginate: 10,
      paginate_total: 0,
      client_contact_current: 1,
      client_contact_paginate: 10,
      client_contact_paginate_total: 0,
      client_contact_search_filter: '',
      search_filter: '',
      selected_dashboard: {},
      listClientDashboardDataSetsPopup: false,
      listClientDashboardDataSetsUserPermissionPopup: false,
      client_access_token: null,
      client_dashboard_lists: [],
      docs_template_lists: [],
      primary_client: null,
      abilities: null,
      prev_campaign_code: null,
      briefing_document: "",
      end_of_campaign_report: "",
      prevClientName: null,
      prevCampaignManager: null,
      prevPrimaryContact: null,
      prevSalesDeveloper1: null,
      prevSalesDeveloper2: null,
      prevSalesDeveloper3: null,
      campaignManagers: [],
      salesDevelopers: [],
      primaryClientContacts: [],
      campaignStatusList: [],
      clientSearchComponentKey: 0,
      campaignSearchComponentKey: 0,
      primaryConctSearchComponentKey: 0,
      elomarkUserSearchComponentKey: 0,
      companySearchComponentKey: 0,
      langHe: he,
      langEn: en,
      disabledStartDates: {
        to: new Date(Date.now() - 8640000)
      },
      disabledEndDates: {
        to: new Date(Date.now() - 8640000)
      },
      campaignDescription: {
        previous_selected_po_setup_id: 0,
        previous_setup_value: 0,
        main_purchase_order_counter: 0,
        campaign_po_and_po_allocated_value: [],
        noSdRequired: false,
        selected_email_template: null,
        selected_docs_template: null,
        alert_opportunity_owner: false,
        primary_client: null,
        daily_rate: null,
        target_no_of_opportunities: null,
        target_no_of_vacs: null,
        campaign_name: null,
        campaign_code: null,
        client_id: null,
        campaign_manager: null,
        primary_client_contact: null,
        start_date: null,
        end_date: null,
        budget: null,

        campaign_status: null,
        selected_campaign_status: {
          campaign_status_description: "Scheduled",
          id: "c89643af-fe71-4c1e-9640-1f578177c345",
          updated_at: "2021-02-21T14:13:44.484540",
          campaign_status: "not_started"
        },
        briefing_document: null,
        end_of_campaign_report: null,
        selected_sales_developer: [],
        selected_campaign_manager: [],
        main_client_counter: 0,
        main_elomark_counter: 0,
        main_sales_developer_counter: 0,
        clients: [
          {
            counter: 0,
            client_id: null,
            primary_contact_id: null,
            client_name: null,
            primary_contact_name: null,
            other_contact_id: [],
            other_contact_name: [],
          }
        ],
        sales_developers: [
          {
            counter: 0,
            full_name: null

          }
        ],
        user_campaign_association: [
          {
            counter: 0,
            id: null,
            name: null
          }
        ]
      }
    };
  },
  components: {
    "v-select": vSelect,
    moduleCampaignManagement,
    ClientAutocomplete,
    Datepicker,
    moduleElomarkUserManagement,
    moduleClientUserManagement,
    CampaignManagerAutocomplete,
    SalesDeveloperAutocomplete,
    PrimaryContactAutocomplete,
    ElomarkUserAutocomplete,
    POAutocomplete,
    SdAllocationPanel
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }

    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }
    if (!moduleClientUserManagement.isRegistered) {
      this.$store.registerModule(
        "clientUsersManagement",
        moduleClientUserManagement
      );
      moduleClientUserManagement.isRegistered = true;
    }

    if (!modulePurchaseOrdersManagement.isRegistered) {
      this.$store.registerModule(
        "PurchaseOrdersManagement",
        modulePurchaseOrdersManagement
      );
      modulePurchaseOrdersManagement.isRegistered = true;
    }
  },
  computed: {
    sdBudgetDays() {
      let rate = parseFloat(this.campaignDescription.daily_rate);
      if (isNaN(rate) || rate <= 0) return null;
      let total = 0;
      (this.campaignDescription.purchase_orders || []).forEach(function (po) {
        let v = parseFloat(po.allocated_value);
        if (!isNaN(v)) total += v;
      });
      return total / rate;
    }
  },
  watch: {

    "campaignDescription.setup_purchase_order_id": function (val) {
      let self = this



      let poId = val && typeof val === 'object' ? val.id : val;
      if (!poId) return;

      self.temp_setup_purchase_order_id = val;
      this.campaignDescription.purchase_orders.forEach(function (ele) {
        // ... rest of logic using poId instead of val.id ...
        if (ele.hasOwnProperty('initial_selected_po_id')) {
          if (ele.initial_selected_po_id == poId) {
            ele.remaining_po_value = parseFloat(ele.initial_remaining_po_value) - parseFloat(self.campaignDescription.setup);
          } else {
            ele.remaining_po_value = parseFloat(ele.initial_remaining_po_value);
          }
        } else {
          if (ele.po_id == poId) {
            ele.remaining_po_value = parseFloat(ele.initial_remaining_po_value) - parseFloat(self.campaignDescription.setup);
          } else {
            ele.remaining_po_value = parseFloat(ele.initial_remaining_po_value);
          }
        }







        if (ele.remaining_po_value < ele.allocated_value) {
          self.$vs.dialog({
            accept: self.acceptAlert,
            color: "primary",
            title: `Purchase Order`,
            text:
              "There are not enough funds available on this PO.  Please either reduced the funds allocated to other campaignDescription OR select a different PO to allocate funds from.",
          });

          ele.remaining_po_value = parseFloat(ele.initial_remaining_po_value)

        }

      })
    },

    "campaignDescription.start_date": function (val) {
      this.disabledEndDates = {
        // to: new Date(Date.parse(val) + 86400)
        to: new Date(Date.parse(val))
      };
    },
    "selected_dashboard": function (val) {

      if (val) {
        this.errors.clear();
      }
    },
    "client_dashboard_custom_name": function (val) {

      if (val) {
        this.errors.clear();
      }
    },
  },
  mounted() {
    this.getAllSalesDeveloper();
    this.getCampaignStatus();
    this.getPurchaseOrderList().then(() => {
      this.campaignId = this.$route.params.campaignId;
      this.init();
    });
  },
  methods: {
    onSetupInput() {
      const setup = parseFloat(this.campaignDescription.setup);
      if (isNaN(setup)) return;
      if (setup < 0) { this.campaignDescription.setup = 0; return; }
      const setupPo = this.campaignDescription.setup_purchase_order_id;   // v-select object
      if (!setupPo || !setupPo.id) {
        this.$vs.notify({
          color: 'warning', title: 'Select the Setup PO first',
          text: 'Choose the Setup Purchase Order (next to the Setup box) before entering a setup fee.',
        });
        return;
      }
      const available = parseFloat(setupPo.remaining_po_value);
      if (!isNaN(available) && setup > available) {
        this.campaignDescription.setup = available;
        this.$vs.notify({
          color: 'warning', title: 'Setup fee capped',
          text: `Only ${available} is available on PO ${setupPo.po_number || ''} — the setup fee was reduced.`,
        });
      }
    },

    onAllocationInput(ind) {
      const row = this.campaignDescription.purchase_orders[ind];
      const entered = parseFloat(row.allocated_value);
      const available = parseFloat(row.remaining_po_value);
      if (isNaN(entered)) return;
      if (entered < 0) { row.allocated_value = 0; return; }
      if (!isNaN(available) && entered > available) {
        row.allocated_value = available;
        this.$vs.notify({
          color: 'warning', title: 'Allocation capped',
          text: `Only ${available} is available on this PO — the value was reduced.`,
        });
      }
    },
    onNoSdRequiredToggle() {
      // Option C (SDA CHANGE 02): the tick is refused while any SD is assigned.
      // Unticking is always allowed.
      if (!this.campaignDescription.noSdRequired) return;
      var hasSds = (this.campaignDescription.sales_developers || []).some(function (row) {
        return !!(row && (row.full_name || row.name));
      });
      if (!hasSds) return;
      var self = this;
      this.$nextTick(function () {
        self.campaignDescription.noSdRequired = false;
      });
      this.$vs.notify({
        color: "warning",
        title: "Sales Developers still assigned",
        text: "This campaign has Sales Developers assigned. Remove them (the X beside each row) before ticking \"No Sales Developer required\".",
        time: 8000
      });
    },
    getAllSalesDeveloper() {
      let filter = {};
      filter.user_role = "Sales Developer";
      filter.user_id = this.user_id;
      var self = this;
      return this.$store
        .dispatch("campaignsManagement/getAllSalesDevelopers", filter)
        .then(res => {
          let data = JSON.parse(res.data);
          if (data) {
            let sales = data.filter(function (ele) {
              ele.label = ele.first_name + " " + ele.surname
              ele.value = ele.uuid
              return ele
            })
            self.allSalesDevelopers = data

          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    acceptAlert() {
      this.campaignDescription.setup = 0;

    },
    getPurchaseOrderList() {
      return this.$store  // ← add return
        .dispatch("PurchaseOrdersManagement/fetchPurchaseOrdersList")
        .then(res => {
          this.PurchaseOrderList = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    // getPurchaseOrderList() {
    //   this.$store
    //     .dispatch("PurchaseOrdersManagement/fetchPurchaseOrdersList")
    //     .then(res => {



    //       this.PurchaseOrderList = res.data



    //     })
    //     .catch(err => {
    //       console.error(err);
    //     });
    // },
    refreshAutocomplete() {
      this.clientSearchComponentKey += 1
    },
    downloadOpportunityDocs() {
      let self = this

      let data = {}
      data.selected_opportunity_docs = self.selected_opportunity_docs
      self.$store
        .dispatch("campaignsManagement/downloadOpportunityDocs", data)
        .then(res => {
          let response = res.data
          if (response) {
            let fileName = null
            if (data.selected_opportunity_docs.length <= 1) {
              fileName = `${+ new Date()}.pdf`
              var blob = new Blob([response], { type: "application/pdf" });
              saveAs(blob, fileName);
            } else {
              fileName = `${+ new Date()}.zip`
              var blob = new Blob([response], { type: "application/octet-stream" });
              saveAs(blob, fileName);
            }

          }
        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })

    },
    submitDocsTemplate() {
      let self = this
      self.showDocsTemplatePopup = false
    },
    submitEmailTemplate() {
      let self = this
      self.showEmailTemplatePopup = false
    },
    updateAlertRecipientsSelection() {
      let self = this
      let data = {}
      data.campaign_id = self.campaignId
      data.alert_recipients_client_user = self.alert_recipients_client_user
      data.alert_recipients_elomark_user = self.alert_recipients_elomark_user
      self.$store
        .dispatch("campaignsManagement/updateCampaignAlertRecipients", data)
        .then(res => {
          let response = res.data
          if (response) {
            self.showAlertRecipientsPopup = false
            self.alert_recipients_client_user = []
            self.alert_recipients_elomark_user = []
          }
        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })

    },
    showAlertRecipients() {
      let self = this
      self.campaignDescription.alert_recipients.forEach(function (ele) {

        if (ele.is_client == 'y') {
          self.alert_recipients_client_user.push(ele.uuid)
        }
        else {
          self.alert_recipients_elomark_user.push(ele.uuid)
        }
        return ele
      })


      self.showAlertRecipientsPopup = true

    },
    showDocsTemplate() {
      let self = this
      this.$store.dispatch("campaignsManagement/getDocsTemplateLists")
        .then(res => {
          let result = res.data
          this.docs_template_lists = result

          self.docs_template_paginate_total = Math.ceil(self.docs_template_lists.length / self.docs_template_paginate);


          self.showDocsTemplatePopup = true




        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });



    },
    showEmailTemplate() {
      let self = this
      this.$store.dispatch("campaignsManagement/getEmailTemplateLists")
        .then(res => {
          let result = res.data
          this.email_template_lists = result
          self.email_template_paginate_total = Math.ceil(self.email_template_lists.length / self.email_template_paginate);

          self.showEmailTemplatePopup = true




        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });



    },
    showOpportunityDocs() {
      let self = this
      let campaign_id = this.$route.params.campaignId;
      this.$store.dispatch("campaignsManagement/getCampaignOpportunityDocsLists", campaign_id)
        .then(res => {
          let result = res.data
          this.opportunity_docs_lists = result
          self.opportunity_docs_paginate_total = Math.ceil(self.opportunity_docs_lists.length / self.opportunity_docs_paginate);

          self.showOpportunityDocsPopup = true



        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });



    },
    clientContactDashboardPermissionOnChange(e, data) {
      let self = this


      if (e.target !== undefined) {

        if (e.target.checked) {
          self.client_dashboard_user_permission_client_user.push(data)

        } else {


          self.client_dashboard_user_permission_client_user.splice(self.client_dashboard_user_permission_client_user.findIndex(function (i) {
            if (i.client_id == data.client_id) {
              return i.uuid == data.primary_contact_id;
            }
          }), 1);

          self.client_dashboard_user_permission_client_user.splice(self.client_dashboard_user_permission_client_user.findIndex(function (i) {
            if (i.client_id == data.client_id) {
              return i.uuid == data.primary_contact_id;
            }
          }), 1);



        }

      }




    },
    otherContactDashboardPermissionOnChange(e, data) {
      let self = this
      if (e.target !== undefined) {

        if (e.target.checked) {
          self.client_dashboard_user_permission_client_user.push(data)

        } else {

          self.client_dashboard_user_permission_client_user.splice(self.client_dashboard_user_permission_client_user.findIndex(function (i) {
            if (i.client_id == data.client_id) {
              return i.uuid == data.primary_contact_id;
            }
          }), 1);

          self.client_dashboard_user_permission_client_user.splice(self.client_dashboard_user_permission_client_user.findIndex(function (i) {
            if (i.client_id == data.client_id) {
              return i.uuid == data.primary_contact_id;
            }
          }), 1);



        }

      }




    },
    clientContactOnChange(e, data) {
      let self = this
      if (e.target.checked) {
        self.selected_client_contact.push(data)
      } else {
        const idToRemove = data.id;
        self.selected_client_contact = self.selected_client_contact.filter((item) => item.id !== idToRemove);



      }

      const key = 'id';

      self.selected_client_contact = [...new Map(self.selected_client_contact.map(item => [item[key], item])).values()];

    },
    removeNotPermissionUserForDashboard(users) {
      let self = this
      let data = {}
      data.campaign_id = self.campaignId
      data.users = users
      self.$store
        .dispatch("campaignsManagement/removeNotPermissionUserForDashboard", data)
        .then(res => {
          let response = res.data
          if (response) {

          }
        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })





    },
    removeNotPermissionUserForAlertRecipients(users) {
      let self = this
      let data = {}
      data.campaign_id = self.campaignId
      data.users = users
      self.$store
        .dispatch("campaignsManagement/removeNotPermissionUserForAlertRecipients", data)
        .then(res => {
          let response = res.data
          if (response) {

          }
        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })





    },
    showSelectedClientDashboardPermission(dashboard) {
      this.listClientDashboardDataSetsUserPermissionPopup = true
      this.update_client_dashboard_user_permission = true
      this.selected_client_dashboard_for_update_permission = dashboard
      this.getAllDashboardUserPermission(dashboard)
    },
    getAllDashboardUserPermission(dashboard) {
      let self = this
      dashboard.permission.forEach(function (ele) {

        if (ele.is_client == 'y') {
          self.client_dashboard_user_permission_client_user.push(ele.uuid)
        }
        else {
          self.client_dashboard_user_permission_elomark_user.push(ele.uuid)
        }
        return ele
      })
    },
    getAllClientContacts(client_id, index) {
      let self = this
      let data = {};
      data.client_id = client_id;
      return self.$store
        .dispatch("clientUsersManagement/getAllClientContacts", data)
        .then(res => {
          let result = res.data;
          self.all_client_contact = result
          self.client_contact_paginate_total = Math.ceil(self.all_client_contact.length / self.client_contact_paginate);


          self.all_client_contact = self.all_client_contact.filter(item => {
            return item.id != self.campaignDescription.clients[index].primary_contact_id;
          });

        })
        .catch(err => {
          console.log(err)

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    selectOtherClientContact() {



      this.campaignDescription.clients[this.other_contact_id_index].other_contact_id = this.selected_client_contact
      this.campaignDescription.clients[this.other_contact_id_index].other_contact_name = this.selected_client_contact
      this.showClientContactPopup = false
    },
    addOtherClientContact(client, index) {
      this.other_contact_id_index = index
      if (client.client_id) {
        this.showClientContactPopup = true



        this.getAllClientContacts(client.client_id, index)

        let client_contact = []

        this.existing_client_contacts.forEach(function (e) {
          if (e.client_id == client.client_id) {

            client_contact.push(e)
          }

        })

        this.selected_client_contact = client_contact

      }



    },
    submitDashboardSelection() {
      let self = this
      this.errors.clear();
      self.$validator.validateAll('AddEditClientDashboard').then(result => {

        if (
          Object.keys(self.selected_dashboard).length === 0) {
          this.errors.add({
            field: "client_dashboard_required",
            msg: "Please select one of the dashboard"
          });
          result = false;
        }

        if (self.client_dashboard_custom_name == null) {
          this.errors.add({
            field: "client_dashboard_custom_name_required",
            msg: "Name field is required"
          });
          result = false;
        }







        if (result) {

          self.listClientDashboardDataSetsPopup = false
          self.listClientDashboardDataSetsUserPermissionPopup = true
          self.update_client_dashboard_user_permission = false





          self.selected_client_dashbashboards.push({
            id: self.selected_dashboard.data_set_id,
            data_set_id: self.selected_dashboard.data_set_id,
          });

        }




      })




    },
    submitDashboardUserPermissionSelection() {
      let self = this
      // this.$vs.loading();
      let data = {}
      data.selected_client_dashbashboards = self.selected_client_dashbashboards
      data.client_dashboard_custom_name = self.client_dashboard_custom_name
      data.client_dashboard_custom_description = self.client_dashboard_custom_description
      data.html = self.html
      data.campaign_id = self.campaignId
      data.user_id = self.user_id
      data.client_dashboard_user_permission_client_user = self.client_dashboard_user_permission_client_user
      data.client_dashboard_user_permission_elomark_user = self.client_dashboard_user_permission_elomark_user
      data.update_client_dashboard_user_permission = self.update_client_dashboard_user_permission
      self.$store
        .dispatch("campaignsManagement/addCampaignDashboardWithPermission", data)
        .then(res => {
          let response = res.data
          if (response) {
            self.listClientDashboardDataSetsPopup = false
            self.listClientDashboardDataSetsUserPermissionPopup = false
            self.selected_dashboard = {}
            self.client_dashboard_user_permission_client_user = []
            self.client_dashboard_user_permission_elomark_user = []
            self.client_dashboard_custom_name = null
            self.client_dashboard_custom_description = null
            self.init()
          }
        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })


      // insert to db



    },
    updateDashboardUserPermissionSelection() {
      let self = this
      // console.log(self.client_dashboard_user_permission_client_user)
      // return false
      // this.$vs.loading();
      let data = {}
      data.client_dashboard_db_id = self.selected_client_dashboard_for_update_permission.id
      data.client_dashboard_custom_name = self.selected_client_dashboard_for_update_permission.name
      data.campaign_id = self.campaignId
      data.client_dashboard_user_permission_client_user = self.client_dashboard_user_permission_client_user
      data.client_dashboard_user_permission_elomark_user = self.client_dashboard_user_permission_elomark_user
      self.$store
        .dispatch("campaignsManagement/updateCampaignDashboardPermission", data)
        .then(res => {
          let response = res.data
          if (response) {
            self.listClientDashboardDataSetsPopup = false
            self.listClientDashboardDataSetsUserPermissionPopup = false
            self.selected_dashboard = {}
            self.client_dashboard_user_permission_client_user = []
            self.client_dashboard_user_permission_elomark_user = []
            self.client_dashboard_custom_name = null
            self.client_dashboard_custom_description = null
            self.init()
          }
        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })


      // insert to db



    },

    setPaginate: function (i) {
      if (this.current == 1) {
        return i < this.paginate;
      }
      else {
        return (i >= (this.paginate * (this.current - 1)) && i < (this.current * this.paginate));
      }
    },
    updateCurrent: function (i) {
      this.current = i;
    },
    updatePaginate: function () {
      this.current = 1;
      this.paginate_total = Math.ceil(document.querySelectorAll(".all_dashboard_rows").length / this.paginate);
    },
    clientContactSetPaginate: function (i) {
      if (this.client_contact_current == 1) {
        return i < this.client_contact_paginate;
      }
      else {
        return (i >= (this.client_contact_paginate * (this.client_contact_current - 1)) && i < (this.client_contact_current * this.client_contact_paginate));
      }
    },
    clientContactUpdateCurrent: function (i) {
      this.client_contact_current = i;
    },
    clientContactUpdatePaginate: function () {
      this.client_contact_current = 1;
      this.client_contact_paginate_total = Math.ceil(document.querySelectorAll(".all_client_contact_rows").length / this.client_contact_paginate);
    },
    docsTemplateSetPaginate: function (i) {
      if (this.docs_template_current == 1) {
        return i < this.docs_template_paginate;
      }
      else {
        return (i >= (this.docs_template_paginate * (this.docs_template_current - 1)) && i < (this.docs_template_current * this.docs_template_paginate));
      }
    },
    docsTemplateUpdateCurrent: function (i) {
      this.docs_template_current = i;
    },
    docsTemplateUpdatePaginate: function () {
      this.docs_template_current = 1;
      this.docs_template_paginate_total = Math.ceil(document.querySelectorAll(".all_docs_template_rows").length / this.docs_template_paginate);
    },
    opportunityDocsSetPaginate: function (i) {
      if (this.opportunity_docs_current == 1) {
        return i < this.opportunity_docs_paginate;
      }
      else {
        return (i >= (this.opportunity_docs_paginate * (this.opportunity_docs_current - 1)) && i < (this.opportunity_docs_current * this.opportunity_docs_paginate));
      }
    },
    opportunityDocsUpdateCurrent: function (i) {
      this.opportunity_docs_current = i;
    },
    opportunityDocsUpdatePaginate: function () {
      this.opportunity_docs_current = 1;
      this.opportunity_docs_paginate_total = Math.ceil(document.querySelectorAll(".all_opportunity_docs_rows").length / this.opportunity_docs_paginate);
    },
    emailTemplateSetPaginate: function (i) {
      if (this.email_template_current == 1) {
        return i < this.email_template_paginate;
      }
      else {
        return (i >= (this.email_template_paginate * (this.email_template_current - 1)) && i < (this.email_template_current * this.email_template_paginate));
      }
    },
    emailTemplateUpdateCurrent: function (i) {
      this.email_template_current = i;
    },
    emailTemplateUpdatePaginate: function () {
      this.email_template_current = 1;
      this.email_template_paginate_total = Math.ceil(document.querySelectorAll(".all_email_template_rows").length / this.email_template_paginate);
    },
    updateCampaignDashboard(inputValue) {
      let data = {};
      data.access_token = this.client_access_token;
      data.search = inputValue;
      return this.$store
        .dispatch("campaignsManagement/updateCampaignDashboard", data)
        .then(res => {
          let result = res.data;
          if (result) {
            result = result.value
            let mappedArray = [];
            for (const property in result) {
              mappedArray.push({
                id: result[property].id,
                name: result[property].name
              });
            }
            return mappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    addPurchaseOrders() {
      this.clientSearchComponentKey += 1;
      this.campaignDescription.purchase_orders.push({
        counter: ++this.campaignDescription.main_purchase_order_counter,
        po_id: null,
        remaining_po_value: null,
        already_allocated_value: null,
        campaign_id: this.campaignId
      });


    },
    listClientDashboardDataSets() {
      let self = this
      self.client_dashboard_user_permission_client_user = []
      self.client_dashboard_user_permission_elomark_user = []


      this.$vs.loading();
      let data = {}
      data.access_token = self.client_access_token
      self.$store
        .dispatch("campaignsManagement/listClientDashboardDataSets", data)
        .then(res => {
          let response = res.data
          if (response) {
            self.client_dashboard_lists = response


            console.log("self.client_dashboard_lists", self.client_dashboard_lists)

            self.paginate_total = Math.ceil(self.client_dashboard_lists.length / self.paginate);
            self.listClientDashboardDataSetsPopup = true
            self.$vs.loading.close();
          }
        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })

    },
    removeExistingClientDashboard(dashboard) {
      let self = this
      let data = {}
      data.client_dashboard_custom_name = dashboard.name
      data.campaign_id = self.campaignId
      data.user_id = self.user_id
      self.$store
        .dispatch("campaignsManagement/removeCampaignDashboardWithPermission", data)
        .then(res => {
          let response = res.data
          if (response) {
            self.init();
          }
        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })





    },
    removeSelectedSalesDeveloper(user) {

      console.log(user)
      this.campaignDescription.sales_developers = this.campaignDescription.sales_developers.filter(
        item => {
          return item.counter != user.counter;
        }
      );

      // if (this.campaignDescription.sales_developers.length == 0) {
      //   this.addSalesDeveloper()
      // } else {
      //   this.companySearchComponentKey += 1;
      // }


    },

    removeSelectedCampaignManager(user_id) {

      // this.campaignDescription.selected_campaign_manager = null

      this.prevCampaignManager = null
    },
    removeSelectedClient(client) {
      this.campaignDescription.clients = this.campaignDescription.clients.filter(
        item => {
          return item.client_id != client.client_id;
        }
      );

      if (this.campaignDescription.clients.length == 0) {
        this.addClients()
      } else {
        this.companySearchComponentKey += 1;
      }


      // this.companySearchComponentKey += 1;
    },
    addElomarkUser() {
      this.campaignDescription.user_campaign_association.push({
        counter: ++this.campaignDescription.main_elomark_counter,
        id: null,
        name: null
      });
    },
    removeSelectedElomarkUser(user) {




      this.campaignDescription.user_campaign_association = this.campaignDescription.user_campaign_association.filter(
        item => {
          return item.id != user.id;
        }
      );

    },
    addClients() {
      this.clientSearchComponentKey += 1;
      this.campaignDescription.clients.push({
        counter: ++this.campaignDescription.main_client_counter,
        client_id: null,
        primary_contact_id: null,
        client_name: null,
        primary_contact_name: null
      });
    },
    handlePrimaryContacts(val) {
      this.campaignDescription.clients[val].primary_contact_id =
        moduleClientUserManagement.state.client_user.id;
      this.campaignDescription.selected_primary_client_contact = val;
      this.$validator.errors.clear()


    },
    handleCampaignManager(val) {
      this.campaignDescription.selected_campaign_manager = val;
      this.prevCampaignManager = val.name
      this.$validator.errors.clear()
    },
    handleElomarkUserEvent(val) {
      this.campaignDescription.user_campaign_association[val].id =
        moduleElomarkUserManagement.state.elomark_user.id;
      this.$validator.errors.clear()

    },
    getPrimaryContacts(inputValue) {
      let data = {};
      data.client_id = this.campaignDescription.client_id;
      data.search = inputValue;
      return this.$store
        .dispatch("clientUsersManagement/getPrimaryContacts", data)
        .then(res => {
          let result = res.data;
          if (result) {
            let mappedArray = [];
            for (const property in result) {
              mappedArray.push({
                id: result[property].id,
                name:
                  result[property].first_name + " " + result[property].surname
              });
            }
            return mappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    searchCampaignManager(inputValue) {
      let data = {};
      data.role = "Campaign Manager";
      data.search = inputValue;
      return this.$store
        .dispatch("elomarkUsersManagement/getElomarkUsersByRole", data)
        .then(res => {
          let result = res.data;
          if (result) {
            // console.log(data);
            let mappedArray = [];
            for (const property in result) {
              mappedArray.push({
                id: result[property].uuid,
                name:
                  result[property].first_name + " " + result[property].surname
              });
            }
            return mappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    handleSelectedPO(index) {
  let self = this
  const selectedPO = modulePurchaseOrdersManagement.state.autocomplete_selected

  // ✅ STEP 1: CHECK FOR DUPLICATE FIRST (BEFORE ASSIGNING ANYTHING)
  const selectedId = selectedPO.id
  const alreadyUsed = this.campaignDescription.purchase_orders
    .some((row, i) => i !== index && (row.po_id || row.id) === selectedId)
  
  if (alreadyUsed) {
    this.$vs.dialog({
      color: 'danger',
      title: 'Purchase Order',
      acceptText: 'OK',
      text: 'This purchase order is already allocated to this campaign. '
        + 'Each PO can be used once for the campaign allocation '
        + '(plus once for the setup fee).',
    })
    // ✅ CLEAR THE ROW (don't let the bad PO stay on screen)
    this.campaignDescription.purchase_orders[index].id = null
    this.campaignDescription.purchase_orders[index].po_id = null
    this.campaignDescription.purchase_orders[index].po_number = null
    this.campaignDescription.purchase_orders[index].remaining_po_value = null
    return  // Stop here, don't process further
  }

  // ✅ STEP 2: ONLY IF DUPLICATE CHECK PASSES, DO THE REST

  this.selected_po_numbers.push({ 'index': index, 'po_number': selectedPO.name })

  self.all_po_data.forEach(function (ele) {
    if (ele.po_number == selectedPO.name) {
      self.campaignDescription.purchase_orders[index].remaining_po_value = parseFloat(selectedPO.remaining_po_value) + parseFloat(ele.allocated_value)
    }
    else {
      self.campaignDescription.purchase_orders[index].remaining_po_value = selectedPO.remaining_po_value
    }
  })

  // ✅ STEP 3: NOW ASSIGN THE PO (after we know it's valid)
  this.campaignDescription.purchase_orders[index].id = selectedPO.id
  this.campaignDescription.purchase_orders[index].po_id = selectedPO.id

  this.clientSearchComponentKey += 1
},
    removePurchaseOrder(po) {

      this.clientSearchComponentKey += 1;

      this.campaignDescription.purchase_orders = this.campaignDescription.purchase_orders.filter(item => {
        return item.counter != po.counter;
      });


      // if (this.campaignDescription.purchase_orders.length == 0) {
      //   this.addPurchaseOrders()
      // } else {
      //   this.clientSearchComponentKey += 1;
      // }



    },
    searchPO(inputValue) {
      return this.$store
        .dispatch("PurchaseOrdersManagement/searchPurchaseOrders", inputValue)
        .then(res => {
          let result = res.data;

          if (result) {
            let POmappedArray = [];
            for (const property in result) {
              POmappedArray.push({
                id: result[property].id,
                name:
                  result[property].po_number,
                remaining_po_value:
                  result[property].remaining_po_value
              });
            }


            var self = this
            const newMappedArray = POmappedArray.filter(({ id: id1 }) => !self.campaignDescription.purchase_orders.some(({ id: id2 }) => id2 == id1));
            return newMappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    searchElomarkUser(inputValue) {
      return this.$store
        .dispatch("elomarkUsersManagement/searchElomarkUser", inputValue)
        .then(response => {
          if (response) {
            let data = moduleElomarkUserManagement.state.elomark_user;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name: data[property].first_name + " " + data[property].surname
                });
              }
              var self = this;
              const results = mappedArray.filter(
                ({ id: id1 }) =>
                  !self.campaignDescription.user_campaign_association.some(
                    ({ id: id2 }) => id2 === id1
                  )
              );
              return results;
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },

    CheckUniqueCampaignCode() {
      if (this.prev_campaign_code != this.campaignDescription.campaign_code) {
        return this.$store
          .dispatch(
            "campaignsManagement/checkUniqueCampaignCode",
            this.campaignDescription.campaign_code
          )
          .then(response => {
            if (response) {
              if (response.data != null) {
                this.$vs.notify({
                  color: "danger",
                  title: "Duplicate Campaign Code",
                  text: "Campaign Code Already exists. Please try another"
                });
                return;
              }
            }
          })
          .catch(err => {
            if (err.response.status === 404) {
              console.log("Error");
              return [];
            }
            console.error(err);
          });
      }
    },
    init() {
      let self = this;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", this.campaignId)
        .then(res => {
          this.campaignDescription = res.data;

          this.campaignDescription.main_purchase_order_counter = 0; // <-- ADD THIS

          this.initial_setup_value = this.campaignDescription.setup
          this.previous_selected_po_setup_id = this.campaignDescription.setup_purchase_order_id

          this.campaignDescription.previous_selected_po_setup_id = this.campaignDescription.setup_purchase_order_id

          this.campaignDescription.previous_setup_value = this.campaignDescription.setup

          //  console.log("DESC" , this.campaignDescription)

          this.prev_campaign_code = this.campaignDescription.campaign_code;
          this.campaignDescription.clients = this.campaignDescription.client_campaign_association;

          this.selected_docs_template = this.campaignDescription.selected_docs_template
          this.selected_email_template = this.campaignDescription.selected_email_template


          if (this.campaignDescription.sales_developers === undefined) {
            this.$set(this.campaignDescription, 'sales_developers', [{
              counter: 0,
              full_name: null,
              id: null
            }]);
          } else {
            this.campaignDescription.sales_developers.forEach(function (ele, index) {
              ele.counter = index;
              ele.full_name = ele.first_name + " " + ele.surname;
              ele.id = ele.uuid;
              return ele;
            });
          }

          // SD Time Allocation: seed the exemption flag + per-SD allocations from
          // the SDA summary endpoint (RECONCILED 2026-08-03: fetchCampaign is NOT
          // extended by the backend build — GET /sd_allocation_summary/<id>
          // provides both no_sd_required and per-SD allocated_hours).
          var editSelf = this;
          this.$set(this.campaignDescription, 'noSdRequired', false);
          this.$set(this.campaignDescription, 'allocationExempt', false);
          this.$store
            .dispatch("campaignsManagement/getSdAllocationSummary", this.$route.params.campaignId)
            .then(function (sumRes) {
              var d = sumRes.data && sumRes.data.data ? sumRes.data.data : null;
              if (!d) return;
              editSelf.$set(editSelf.campaignDescription, 'noSdRequired', !!d.no_sd_required);
              editSelf.$set(editSelf.campaignDescription, 'allocationExempt', !!d.allocation_exempt);
              (editSelf.campaignDescription.sales_developers || []).forEach(function (row) {


                var m = (d.sales_developers || []).find(function (s) {
                  return s.sales_developer_id == (row.uuid || row.id);
                });

                editSelf.$set(row, 'originalHours', m && m.allocated_hours != null ? m.allocated_hours : null);
              });
            })
            .catch(function () { /* summary unavailable: panel treats all rows as unallocated */ });










          // console.log(self.campaignDescription)

          this.campaignDescription.client_campaign_association = this.campaignDescription.client_campaign_association.filter(
            function (e) {
              //check primary client
              let data = {};
              data.campaignId = self.campaignId;
              data.clientId = e.id;

              self.$store
                .dispatch("campaignsManagement/checkCampaignPrimaryClient", {
                  data
                })
                .then(res => {
                  if (res.data) {
                    let result = JSON.parse(res.data);
                    if (result.length != 0) {
                      self.primary_client = result[0].client_id;

                    }
                  }
                })
                .catch(err => { });

              e.campaign_client_id = e.id;
              return e;
            }
          );
          // return false
          let client_campaign_association = this.campaignDescription
            .client_campaign_association;
          let user_campaign_association = this.campaignDescription
            .user_campaign_association;

          let all_associated_users = this.campaignDescription.user_campaign_association

          this.campaignDescription.user_campaign_association = all_associated_users.filter(
            function (ele) {
              return ele.is_client == "n";
            }
          );


          let other_client_user_campaign_association = all_associated_users.filter(
            function (ele) {
              return ele.is_client == "y";
            }
          );

          this.existing_client_contacts = other_client_user_campaign_association

          let merge_clients_primary_contacts = [];

          for (let i = 0; i < client_campaign_association.length; i++) {
            merge_clients_primary_contacts.push({
              ...client_campaign_association[i],
              ...(user_campaign_association.find((itmInner) => itmInner.client_id === client_campaign_association[i].id))
            }
            );
          }



          let newArray = [];
          merge_clients_primary_contacts = merge_clients_primary_contacts.filter(
            function (item, index) {

              if (item.is_client == 'y') {

                let newObj = {};
                newObj.counter = index;
                newObj.client_id = item.campaign_client_id;
                newObj.primary_contact_id = item.id;
                newObj.client_name = item.company_name;
                newObj.primary_contact_name =
                  item.first_name + " " + item.surname;
                newObj.other_contact_name = []
                other_client_user_campaign_association.forEach(function (ele) {
                  if (ele.client_id == item.campaign_client_id) {
                    newObj.other_contact_name.push({ 'id': ele.id, 'first_name': ele.first_name, 'surname': ele.surname })
                  }
                })
                newArray.push(newObj);
              }
            }
          );
          this.campaignDescription.clients = newArray;
          this.campaignDescription.main_client_counter =
            this.campaignDescription.clients.length - 1;

          // this.campaignDescription.user_campaign_association = this.campaignDescription.user_campaign_association.filter(
          //   function (ele, index) {
          //     ele.counter = index;
          //     return ele.is_client == "n";
          //   }
          // );


          // console.log("PURCHASE ORDERS" , this.campaignDescription.campaign_pos)

          self.all_po_data = []
          self.campaignDescription.campaign_pos.forEach(function (ele, index) {
            let poObj = {}

            if (ele.uuid == self.campaignDescription.setup_purchase_order_id) {
              poObj = {
                counter: index,
                po_id: ele.uuid,
                po_number: ele.po_number,
                allocated_value: parseFloat(ele.campaign_po_value_allocated),
                campaign_id: self.campaignId,
                remaining_po_value: parseFloat(ele.campaign_po_value_allocated) + parseFloat(ele.remaining_po_value) + parseFloat(self.campaignDescription.setup),
                initial_selected_po_id: self.campaignDescription.setup_purchase_order_id,
                initial_remaining_po_value: parseFloat(ele.campaign_po_value_allocated) + parseFloat(ele.remaining_po_value) + parseFloat(self.campaignDescription.setup),
              }
            } else {
              poObj = {
                counter: index,
                po_id: ele.uuid,
                po_number: ele.po_number,
                allocated_value: parseFloat(ele.campaign_po_value_allocated),
                campaign_id: self.campaignId,
                remaining_po_value: parseFloat(ele.campaign_po_value_allocated) + parseFloat(ele.remaining_po_value),
                initial_remaining_po_value: parseFloat(ele.campaign_po_value_allocated) + parseFloat(ele.remaining_po_value),
              }
            }
            self.all_po_data.push(poObj)




            // campaign_remaining_po_value = parseFloat(ele.campaign_po_value_allocated) + parseFloat(ele.remaining_po_value)


            // console.log(self.all_po_data)


          })


          this.campaignDescription.purchase_orders = self.all_po_data


          const existingCounters = self.all_po_data.map(p => p.counter).filter(c => !isNaN(c));
          this.campaignDescription.main_purchase_order_counter =
            existingCounters.length > 0 ? Math.max(...existingCounters) + 1 : 0;





          //   this.campaignDescription.purchase_orders =  [
          //   {
          //     counter: 0,
          //     po_id: null,
          //     remaining_po_value: 0,
          //   }
          // ],



          this.campaignDescription.main_elomark_counter =
            this.campaignDescription.user_campaign_association.length - 1;

          // var self = this;
          this.campaignStatusList.forEach(function (ele) {
            if (ele.id == self.campaignDescription.campaign_status) {
              self.campaignDescription.selected_campaign_status = ele;
            }
          });


          this.PurchaseOrderList.forEach(function (ele) {

            if (ele.id == self.campaignDescription.setup_purchase_order_id) {
              self.campaignDescription.setup_purchase_order_id = ele;
              self.temp_setup_purchase_order_id = ele
            }
          });

          this.showPrimaryContact(
            self.campaignDescription.primary_client_contact
          );
          this.fetchCampaignManager(self.campaignDescription.campaign_manager);


          this.checkSdAllocationCompliance();



        })
        .catch(err => {
          console.error(err);
        });
    },
    uploadEndOfCampaignReport(e) {
      this.campaignDescription.end_of_campaign_report = null;
      const files = e.target.files;
      const EOCRFile = files[0];
      if (!EOCRFile) return;
      if (
        EOCRFile.type != "application/pdf" &&
        EOCRFile.type != "text/plain" &&
        EOCRFile.type !=
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&
        EOCRFile.type !=
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        EOCRFile.type != "text/csv"
      ) {
        this.$vs.notify({
          color: "danger",
          title: "Invalid File",
          text:
            "The Upload End Of Campaign Report Document Must Be A File Of Type: Docx, Doc, Pdf, Xlsx, Xls, Csv, Txt."
        });
        return;
      }
      this.upload_file_name = EOCRFile.name;
      let axois_url =
        this.$base_url + "/api/campaigns/document_eocr_upload";
      let formData = new FormData();
      formData.append("file", EOCRFile);
      axios
        .post(axois_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status == "success") {
            this.campaignDescription.end_of_campaign_report =
              response.data.data;
          }
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    addSalesDeveloper() {

      let main_counter = this.campaignDescription.sales_developers.length - 1;

      this.campaignDescription.sales_developers.push({
        counter: ++main_counter,
        full_name: null
      });
    },
    onSdAllocationChange(state) {
      this.sdAllocationState = state;
    },
    checkSdAllocationCompliance() {
      var self = this;
      var status = self.campaignDescription.campaign_status_name ||
        (self.campaignDescription.selected_campaign_status
          ? self.campaignDescription.selected_campaign_status.campaign_status : null);




      if (self.campaignDescription.noSdRequired) return;
      if (status != 'Live' && status != 'Scheduled') return;

 if (self.campaignDescription.allocationExempt) return;

      this.$store
        .dispatch("campaignsManagement/getSdAllocationSummary", self.campaignId)
        .then(res => {




          var summary = res.data.data || {};




          var unallocated = (summary.sales_developers || []).filter(function (sd) {
            return sd.allocated_hours == null;
          });



          if (unallocated.length > 0) {
            self.sd_compliance_warning = unallocated.length +
              " Sales Developer(s) on this Live/Scheduled campaign have no time allocation. " +
              "Set their allocation below before further hours are submitted.";
          } else {
            self.sd_compliance_warning = null;
          }

        })
        .catch(function () { /* banner is best-effort; stay silent on failure */ });
    },
    uploadBriefingDocument(e) {
      this.campaignDescription.briefing_document = null;
      const files = e.target.files;
      const briefingFile = files[0];
      if (!briefingFile) return;
      if (
        briefingFile.type != "application/pdf" &&
        briefingFile.type != "text/plain" &&
        briefingFile.type !=
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&
        briefingFile.type !=
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        briefingFile.type != "text/csv"
      ) {
        this.$vs.notify({
          color: "danger",
          title: "Invalid File",
          text:
            "The Briefing Document Must Be A File Of Type: Docx, Doc, Pdf, Xlsx, Xls, Csv, Txt."
        });
        return;
      }
      this.upload_file_name = briefingFile.name;
      let axois_url =
        this.$base_url + "/api/campaigns/document_briefing_upload";
      let formData = new FormData();
      formData.append("file", briefingFile);
      axios
        .post(axois_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status == "success") {
            this.campaignDescription.briefing_document = response.data.data;
          }
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    showClientName(clientId) {
      this.$store
        .dispatch("clientsManagement/fetchClient", clientId)
        .then(res => {
          if (res) {
            let response = res.data;
            this.prevClientName = response.company_name;
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.clientDescription = true;
            return;
          }
          console.error(err);
        });
    },
    showPrimaryContact(UserId) {
      this.$store
        .dispatch("clientUsersManagement/fetchClientUser", UserId)
        .then(res => {
          if (res) {
            this.prevPrimaryContact =
              res.data.first_name + " " + res.data.surname;
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.userDescription = true;
            return;
          }
          console.error(err);
        });
    },
    fetchCampaignManager(UserId) {
      this.$store
        .dispatch("elomarkUsersManagement/fetchElomarkUser", UserId)
        .then(res => {
          this.prevCampaignManager =
            res.data.first_name + " " + res.data.surname;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.userDescription = true;
            return;
          }
          console.error(err);
        });
    },
    async fetchSalesDeveloper(UserId) {
      let result = await this.$store
        .dispatch("elomarkUsersManagement/fetchElomarkUser", UserId)
        .then(res => {
          return res;
        })
        .catch(err => {
          console.log(err);
        });

      return result;
    },
    fetchSalesDeveloper1(UserId) {
      this.$store
        .dispatch("elomarkUsersManagement/fetchElomarkUser", UserId)
        .then(res => {
          this.prevSalesDeveloper1 =
            res.data.first_name + " " + res.data.surname;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.userDescription = true;
            return;
          }
          console.error(err);
        });
    },
    fetchSalesDeveloper2(UserId) {
      this.$store
        .dispatch("elomarkUsersManagement/fetchElomarkUser", UserId)
        .then(res => {
          this.prevSalesDeveloper2 =
            res.data.first_name + " " + res.data.surname;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.userDescription = true;
            return;
          }
          console.error(err);
        });
    },
    fetchSalesDeveloper3(UserId) {
      this.$store
        .dispatch("elomarkUsersManagement/fetchElomarkUser", UserId)
        .then(res => {
          this.prevSalesDeveloper3 =
            res.data.first_name + " " + res.data.surname;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.userDescription = true;
            return;
          }
          console.error(err);
        });
    },
    handleClientEvent(val) {
      // this.clients = moduleClientManagement.state.searched_clients;
      this.campaignDescription.clients[val].client_id =
        moduleClientManagement.state.searched_clients.id;

      this.campaignDescription.client_id = this.campaignDescription.clients[
        val
      ].client_id;

      this.$validator.errors.clear()

      // this.campaignDescription.selected_clients.push(val);
    },
    goBack: function () {
      this.$router
        .push("/campaigns")
        .catch(() => { });
    },
    searchClient(inputValue) {
      return this.$store
        .dispatch("clientsManagement/searchClient", inputValue)
        .then(response => {
          if (response) {
            let data = response.data;
            if (data) {
              let clientMappedArray = [];
              for (const property in data) {
                clientMappedArray.push({
                  id: data[property].id,
                  name: data[property].company_name
                });
              }
              var self = this;
              const newMappedArray = clientMappedArray.filter(
                ({ id: id1 }) =>
                  !self.campaignDescription.clients.some(
                    ({ client_id: id2 }) => id2 == id1
                  )
              );
              return newMappedArray;
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    submitForm() {
      this.errors.clear();
      this.$validator.validateAll().then(result => {

        // Filter out empty sales developers for validation (UI only, don't mutate yet)
        let validSalesDevelopers = this.campaignDescription.sales_developers.filter(ele => ele.full_name != null);

        if (!this.campaignDescription.noSdRequired && validSalesDevelopers.length == 0) {
          this.errors.add({
            field: "sales_developer",
            msg: "Sales Developer field is required"
          });
          result = false;
        }

        if (!this.campaignDescription.noSdRequired && this.sdAllocationState.hasBlocked) {
          this.errors.add({
            field: "sales_developer",
            msg: "One or more Sales Developer allocations exceed the 10 h/day maximum for their availability — reduce the allocation, extend the window, or free up other commitments."
          });
          result = false;
        }

        if (this.campaignDescription.clients.length !== 0) {
          this.campaignDescription.clients.forEach(element => {
            if (
              element.client_id == null ||
              element.primary_contact_id == null
            ) {
              this.errors.add({
                field: "client",
                msg: "Client and Primary Contact is required"
              });
              result = false;
            }
          });
        } else {
          this.errors.add({
            field: "client",
            msg: "Client and Primary Contact is required"
          });
          result = false;
        }

        if (
          this.prevCampaignManager == null
        ) {
          this.errors.add({
            field: "campaign_manager",
            msg: "Campaign Manager is required"
          });
          result = false;
        }

        if (this.campaignDescription.user_campaign_association.length !== 0) {
          this.campaignDescription.user_campaign_association.forEach(
            element => {
              if (element.id == null) {
                this.errors.add({
                  field: "privileged_elomark_user",
                  msg: "Privileged Elomark User field is required"
                });
                result = false;
              }
            }
          );
        } else {
          this.errors.add({
            field: "privileged_elomark_user",
            msg: "Privileged Elomark User field is required"
          });
          result = false;
        }

        if (result) {
          // Create a deep copy for API payload so we don't mutate the reactive UI data
          let payload = JSON.parse(JSON.stringify(this.campaignDescription));

          if (payload.selected_campaign_status) {
            payload.campaign_status = payload.selected_campaign_status.id;
          }
          if (payload.selected_campaign_manager) {
            payload.campaign_manager = payload.selected_campaign_manager.uuid;
          }
          if (payload.start_date) {
            payload.start_date = moment(
              payload.start_date
            ).format("YYYY-MM-DD");
          }
          if (payload.end_date) {
            payload.end_date = moment(
              payload.end_date
            ).format("YYYY-MM-DD");
          }

          payload.user_campaign_association = payload.user_campaign_association.filter(
            (v, i, a) => a.findIndex(t => t.id === v.id) === i
          );

          payload.clients = payload.clients.filter(
            (v, i, a) => a.findIndex(t => t.client_id === v.client_id) === i
          );

          if (payload.campaign_manager) {
            let camp_manager_for_association = {
              id: payload.campaign_manager,
              name: null
            };
            payload.user_campaign_association.push(
              camp_manager_for_association
            );
          }

          payload.primary_client = this.primary_client;

          let campaign_permission_user_ids = [];
          payload.clients.forEach(function (e) {
            campaign_permission_user_ids.push(e.primary_contact_id);

            if (e.other_contact_name) {
              if (e.other_contact_name.length != 0) {
                e.other_contact_name.forEach(function (j) {
                  campaign_permission_user_ids.push(j.id);
                });
              }
            }
          });

          payload.user_campaign_association.forEach(function (e) {
            campaign_permission_user_ids.push(e.id);
          });

          let not_associated_dashboard_permission_users = [];
          payload.campaign_dashboard.forEach(function (e) {
            e.permission.forEach(function (f) {
              if (!campaign_permission_user_ids.includes(f.uuid)) {
                not_associated_dashboard_permission_users.push(f.uuid);
              }
            });
          });

          if (not_associated_dashboard_permission_users.length != 0) {
            this.removeNotPermissionUserForDashboard(not_associated_dashboard_permission_users);
          }

          payload.user_campaign_association.forEach(function (e) {
            campaign_permission_user_ids.push(e.id);
          });

          let not_associated_alert_recipients_users = [];
          payload.alert_recipients.forEach(function (e) {
            if (!campaign_permission_user_ids.includes(e.uuid)) {
              not_associated_alert_recipients_users.push(e.uuid);
            }
          });

          if (not_associated_alert_recipients_users.length != 0) {
            this.removeNotPermissionUserForAlertRecipients(not_associated_alert_recipients_users);
          }

          payload.selected_docs_template = this.selected_docs_template;
          payload.selected_email_template = this.selected_email_template;

          // Convert setup PO object to ID for API — safe because we're mutating payload, not reactive data
          if (payload.setup_purchase_order_id) {
            payload.setup_purchase_order_id = typeof payload.setup_purchase_order_id === 'object'
              ? payload.setup_purchase_order_id.id
              : payload.setup_purchase_order_id;
          }

          payload.purchase_orders.forEach(function (p) {
            if (p.allocated_value == null) {
              alert("Allocated Value cannot be empty");
              throw new Error("Allocated Value cannot be empty");
            }
          });



       


          // --- SD Time Allocation: merge panel output into the save payload ---
          payload.no_sd_required = !!payload.noSdRequired;
          payload.allocation_exempt = !!payload.allocationExempt;


          if (!payload.noSdRequired && !payload.allocationExempt) {
            let allocs = this.sdAllocationState.allocations;
            payload.sales_developers = validSalesDevelopers.map(function (row) {
              let sel = row.full_name && typeof row.full_name === "object" ? row.full_name : null;
              let sd_id = sel ? (sel.uuid || sel.value) : (row.uuid || row.id);
              let match = allocs.find(a => a.salesDeveloperId == sd_id);
              row.allocated_hours = match ? match.allocatedHours : null;
              row.allocation_note = match ? (match.allocationNote || "Initial allocation") : null;
              return row;
            });
          }
          // -------------------------------------------------------------------

          this.updateCampaign(payload);
        }
      });
    },
    getCampaignStatus() {
      this.$store
        .dispatch("campaignsManagement/getCampaignStatus")
        .then(res => {
          this.campaignStatusList = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    updateCampaign(payload) {
      this.$vs.loading()
      this.$store
        .dispatch("campaignsManagement/updateCampaign", payload)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Campaign Updated",
              text: "The campaign was updated successfully"
            });
            this.$router.push({ path: "/campaigns" });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Campaign Updated",
              text: res.data.message,
            });
            this.init(); // Resets from server, restoring object forms
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        }).finally(() => {
              this.$vs.loading.close()
            }) 
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.v-select-box {
  background: none;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
}



.pagination {
  display: inline-block;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  border: 1px solid #ddd;
  /* Gray */
}
</style>
